import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { SearchModalComponent } from './search-modal/search-modal.component';
import { RouterModule } from '@angular/router';
import { FilteredProductListComponent } from './filtered-product-list/filtered-product-list.component';
import { SelectProductComponent } from './select-product/select-product.component';
import { ProductSingleComponent } from './product/product-single.component';
import { ProductSingleRenewComponent } from './product-single-renew/product-single-renew.component';
import { InquiryModule } from '../../mobile/inquiry/inquiry.module';
import { ProductReviewsComponent } from './product-reviews/product-reviews.component';
import { NgxStarsModule } from 'ngx-stars';
// import { ReadMoreModule } from 'ng-readmore';
// import { LightboxModule } from 'ngx-lightbox';
// import { GalleryModule } from '@ngx-gallery/core';
// import { GallerizeModule } from '@ngx-gallery/gallerize';
import { MyMembershipStatusNavigationComponent } from './my-membership-status-navigation/my-membership-status-navigation.component';
import { UnsupportedBrowserComponent } from './unsupported-browser/unsupported-browser.component';
import { SelectBulkProductComponent } from './select-bulk-product/select-bulk-product.component';
import { ProductStockBadgesComponent } from '../../../shared/components/product-stock-badges/product-stock-badges.component';

const COMPONENTS = [
  SearchModalComponent,
  FilteredProductListComponent,
  SelectProductComponent,
  ProductSingleComponent,
  ProductSingleRenewComponent,
  ProductReviewsComponent,
  MyMembershipStatusNavigationComponent,
  UnsupportedBrowserComponent,
  SelectBulkProductComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    RouterModule,
    InquiryModule,
    CommonModule,
    NgxStarsModule,
    // ReadMoreModule,
    // LightboxModule,
    // GalleryModule,
    // GallerizeModule,
    SharedModule,
    ProductStockBadgesComponent,
  ],
  exports: [...COMPONENTS],
})
export class ComponentModule {}
